import { FormattedMessage } from "react-intl";

import { Stack, Text, xcss } from "@atlaskit/primitives-next";

import { Champion } from "../../types";
import { BaseCard } from "../base-card";
import { CardRelationship } from "../card-relationship";

import { messages } from "./messages";

const contentStyles = xcss({
    height: "100%"
});

export const FastshiftChampionCard = ({ champion }: { champion: Champion }) => {
    return (
        <BaseCard message={messages.fastshiftChampionCardTitle}>
            <Stack xcss={contentStyles} space="space.400">
                <Text>
                    <FormattedMessage
                        {...messages.fastshiftChampionCardSubtitle}
                    />
                </Text>
                <CardRelationship
                    name={champion.name}
                    imageUrl={champion.imageUrl}
                    titleMessage={
                        <FormattedMessage
                            {...messages.fastshiftChampionTitle}
                            values={{ title: champion.title }}
                        />
                    }
                />
            </Stack>
        </BaseCard>
    );
};
